
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Activity": [
      "CreatedCommentActivity",
      "CreatedHistoryActivity",
      "FillerActivity",
      "JoinedUserActivity",
      "PublishedPostActivity",
      "RepliedCommentActivity",
      "ThankedPostActivity"
    ],
    "CommentFields": [
      "Comment",
      "PublicComment"
    ],
    "GroupFields": [
      "Group",
      "PublicGroup"
    ],
    "MentionContent": [
      "MentionContentDelta",
      "MentionContentHighlights",
      "MentionContentSlack"
    ],
    "Notification": [
      "CommentNotification",
      "HistoryNotification",
      "InvitationNotification",
      "PostNotification",
      "ReactionNotification"
    ],
    "ObjectWithId": [
      "Comment",
      "CommentReaction",
      "CommentThread",
      "Group",
      "History",
      "Organization",
      "Post",
      "PublicComment",
      "PublicCommentThread",
      "PublicGroup",
      "PublicOrganization",
      "PublicReaction",
      "PublicReactionThread",
      "PublicSection",
      "PublicSeries",
      "PublicTopic",
      "PublicUser",
      "Reaction",
      "ReactionThread",
      "Section",
      "Series",
      "SlimSeries",
      "SlimTopic",
      "SlimUser",
      "Topic",
      "User",
      "VisitorUser"
    ],
    "PostBacklink": [
      "Group",
      "Post",
      "Topic",
      "User"
    ],
    "PostFields": [
      "Post",
      "PublicPost"
    ],
    "ProvisionFavorite": [
      "Post",
      "Topic"
    ],
    "ProvisionMember": [
      "Group",
      "Post",
      "Topic"
    ],
    "PublicSearchResult": [
      "PublicPostSearchResult",
      "PublicTopicSearchResult"
    ],
    "PublicSectionItem": [
      "PublicPost",
      "PublicTopic"
    ],
    "PublicThreadFields": [
      "PublicCommentThread",
      "PublicReactionThread"
    ],
    "ReactionFields": [
      "PublicReaction",
      "Reaction"
    ],
    "RootPostFields": [
      "Post",
      "PublicPost",
      "SlimPost"
    ],
    "RootThreadFields": [
      "CommentThread",
      "PublicCommentThread",
      "PublicReactionThread",
      "ReactionThread"
    ],
    "SearchResult": [
      "CommentSearchResult",
      "GroupSearchResult",
      "PostSearchResult",
      "TopicSearchResult",
      "UserSearchResult"
    ],
    "SectionItem": [
      "Post",
      "Topic"
    ],
    "SeriesFields": [
      "PublicSeries",
      "Series"
    ],
    "SlimPostFields": [
      "Post",
      "SlimPost"
    ],
    "ThreadFields": [
      "CommentThread",
      "ReactionThread"
    ],
    "TopicFields": [
      "PublicTopic",
      "Topic"
    ],
    "UserFields": [
      "PublicUser",
      "User",
      "VisitorUser"
    ]
  }
};
      export default result;
    